export {default as email} from './email';
export {default as length} from './length';
export {default as numericality} from './numericality';
export {default as date} from './date';
export {default as password, confirm as confirmPassword} from './password';
export {default as required} from './required';
export {default as countryName} from './country-name';



// WEBPACK FOOTER //
// ./validators/units/index.js